module.exports = {
  context: {
    masthead: '@masthead',
    hero: {
      type: 'text-only'
    },
    mainContent: {
      heading: 'Adjoin: Together we ignite possbility',
      text: '<h3 class="heading-3">Headquarters</h3><p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto: info@email.org">info@email.org</a></p>',
      locationBlocks: [
        {
          sectionHeading: 'Catalysts Community Services',
          locations: [
            {
              heading: 'San Francisco',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            },
            {
              heading: 'City',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            },
            {
              heading: 'City',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            },
            {
              heading: 'City',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            },
            {
              heading: 'City',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            },
            {
              heading: 'City',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            }
          ]
        },
        {
          sectionHeading: 'Veterans Community Services',
          locations: [
            {
              heading: 'San Francisco',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            },
            {
              heading: 'City',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            },
            {
              heading: 'City',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            },
            {
              heading: 'City',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            },
            {
              heading: 'City',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            },
            {
              heading: 'City',
              text: '<p>12345 Address<br />City, ST Zip<br />555-678-9000<br /><a href="mailto:info@email.org">info@email.org</a></p>'
            }
          ]
        }
      ]
    },
    contactForm: '@contact-form',
    footer: '@footer'
  }
}
